import { render, staticRenderFns } from "./CallPopupContainer.vue?vue&type=template&id=cae22986&scoped=true"
import script from "./CallPopupContainer.vue?vue&type=script&lang=js"
export * from "./CallPopupContainer.vue?vue&type=script&lang=js"
import style0 from "./CallPopupContainer.vue?vue&type=style&index=0&id=cae22986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae22986",
  null
  
)

export default component.exports